export const subUnitToUnit = (
  subUnit: number | string,
  subUnits: number = 100,
): number => {
  const subUnitNumber =
    typeof subUnit === 'number'
      ? subUnit
      : Number.parseFloat(subUnit.replaceAll(/[^\d.-]+/g, ''));

  if (Number.isNaN(subUnitNumber)) {
    throw new TypeError(`Could not parse "${subUnit.toString()}" to number`);
  }

  return subUnitNumber / subUnits;
};

export const unitToSubUnit = (
  unit: number | string,
  subUnits: number = 100,
): number => {
  const unitNumber =
    typeof unit === 'number'
      ? unit
      : Number.parseFloat(unit.replaceAll(/[^\d.-]+/g, ''));

  if (Number.isNaN(unitNumber)) {
    throw new TypeError(`Could not parse "${unit.toString()}" to number`);
  }

  return unitNumber * subUnits;
};

export const formatCurrency = (
  currencyUnit: number,
  options?: Intl.NumberFormatOptions,
): string => {
  return new Intl.NumberFormat(navigator.language, {
    currency: 'USD',
    currencyDisplay: 'narrowSymbol',
    style: 'currency',
    ...options,
  }).format(currencyUnit);
};
